const ArrowRightSpace = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M10.1427 9.9997L7.78516 7.64303L8.96349 6.46387L12.4993 9.9997L8.96349 13.5355L7.78516 12.3564L10.1427 9.9997Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowRightSpace
